import {Proprietario} from 'models/proprietario.model';

export const getNomeProprietario = (p:Proprietario): string => {
    return p.personaFisica? `${p.nome} ${p.cognome}`: p.societa;
}
